export const ATTRIBUTE_TYPES = {
  TEXT: 'text',
  NUMBER: 'number',
  LINK: 'link',
  DATE: 'date',
  DATETIME: 'datetime',
  LIST: 'list',
  CHECKBOX: 'checkbox',
  ACTIVITY: 'activity',
};
